import { OverlayContainer, OverlayContent, OverlayInner, OverlaySpinner, OverlayText } from './style';

interface OverlayProps {
    open: boolean;
    text: string;
}

const Overlay = ({ open, text }: OverlayProps) => {
    return (
        <OverlayContainer open={open}>
            <OverlayInner>
                <OverlayContent>
                    <OverlaySpinner />
                    <OverlayText>
                        {text}
                    </OverlayText>
                </OverlayContent>
            </OverlayInner>
        </OverlayContainer>
    )
};

export default Overlay;